import React, { useState } from "react";
import styled from "styled-components";
import {
  UpArrow,
} from "../../../shared/icons";
import { DownArrow } from "../../../shared/icons";
import { screenSizes } from "../../../styles/theme";

const AccordionWrapper = styled.div<{ isOpen: boolean }>`
  border: 1px solid #091c001a;
  margin: 0px 0 15px;
  width: 100%;
  overflow: hidden;
  padding: 16px 24px;
  @media (max-width: ${screenSizes.L}px) {
    padding: 10px;
  }
  background: ${({ isOpen }) =>
    isOpen
      ? "linear-gradient(134.14deg, #0F2704 20.03%, #121511 79.02%)"
      : "#FFFFFF"};
`;

const Header = styled.div<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 700;
  color: ${({ isOpen }) => (isOpen ? "#FFFFFF" : "#091C00")};
`;

const Content = styled.div<{ isOpen: boolean }>`
  padding: ${(props) => (props.isOpen ? "24px" : "0 0 0 24px")};
  @media (max-width: ${screenSizes.L}px) {
    padding: ${(props) => (props.isOpen ? "15px" : "0")};
  }
  height: ${(props) => (props.isOpen ? "auto" : "0")};
  overflow: hidden;
  transition: height 0.3s ease, padding 0.3s ease;
`;

const Paragraph = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  padding-bottom: 15px;
`;

const AccordionButton = styled.button`
  border: none;
  outline: none;
  color: #ffffff;
  background: none;
  font-size: 16px;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const IconWrapper = styled.span`
  margin-left: 15px;
  display: flex;
  align-items: center;
  svg {
    width: 16px;
    height: 16px;
    fill: white;
  }
`;

interface AccordionProps {
  title: string;
  content: string;
  defaultOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({ title, content, defaultOpen = false  }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <AccordionWrapper isOpen={isOpen}>
      <Header isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {title}
        {isOpen ? <UpArrow /> : <DownArrow />}
      </Header>
      {isOpen && <div style={{borderBottom: "1px solid rgba(255, 255, 255, 0.8)", marginInline:'15px'}}></div>}
      <Content isOpen={isOpen}>
        <Paragraph>{content}</Paragraph>
      </Content>
    </AccordionWrapper>
  );
};

export default Accordion;
